import React from 'react';
import { DocumentCompileFileStatus } from '../type';

export const renderDocumentStatus = (status: number) => {
  const commonStyle: React.CSSProperties = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 20,
    height: 20,
    borderRadius: '50%',
    border: '1px solid',
    fontSize: 12,
  };

  if (status === DocumentCompileFileStatus.COMPILING) {
    return (
      <span style={{ ...commonStyle, borderColor: '#52c41a', color: '#52c41a' }}>
        编
      </span>
    );
  }

  if (status === DocumentCompileFileStatus.COMPLETED) {
    return (
      <span style={{ ...commonStyle, borderColor: '#ff4d4f', color: '#ff4d4f' }}>
        签
      </span>
    );
  }

  return <span></span>;
};

